import { useCallback, useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { useTicketLockStatus } from 'remote-state/ticketServiceHooks';
import { selectActiveUser } from 'store/userSlice';
import { useFeatureFlagQuery } from '../../../../remote-state/featureFlagsHooks';
import { FEATURE_FLAGS_KEYS } from '../../../../constants/featureFlags';
import { QUERIES_KEYS } from '../../../../constant';

const useValidateSrLockBeforeUpdate = ({ srId, handleSaveSR }) => {
  const waitForLock = useRef();
  const activeUser = useSelector(selectActiveUser);
  const queryClient = useQueryClient();

  const { data: lockingDetails } = useTicketLockStatus(srId);
  const { data: isSROpenedFromQueue } = useFeatureFlagQuery({
    flagKey: FEATURE_FLAGS_KEYS.OPEN_SR_FROM_QUEUE,
    defaultValue: false,
  });

  const isLocked = lockingDetails?.isLocked;
  const lockingUser = lockingDetails?.lockingUser;
  const checkAvailableTicket = isSROpenedFromQueue || (isLocked && activeUser?.username === lockingUser);

  const handleUpdateSR = useCallback(
    async (object) => {
      if (checkAvailableTicket) {
        handleSaveSR(object);
      } else {
        queryClient.invalidateQueries([QUERIES_KEYS.TICKET_LOCK_STATUS, Number(srId)]);
        waitForLock.current = object;
      }
    },
    [checkAvailableTicket, handleSaveSR, queryClient, srId],
  );

  const handleWaitForLock = useCallback(async () => {
    if (checkAvailableTicket && waitForLock.current) {
      handleSaveSR(waitForLock.current);
      waitForLock.current = null;
    }
  }, [checkAvailableTicket, handleSaveSR]);

  useEffect(() => {
    handleWaitForLock();
  }, [handleWaitForLock]);

  return { handleUpdateSR };
};

export default useValidateSrLockBeforeUpdate;
